import React from 'react';

import Seo from '../components/Seo';
import GoogleReviewBadge from '../components/GoogleReviewBadge';
import Layout from '../components/layout/Layout';
import HeroImage from '../svg/HeroImage';

import Services from '../components/home/Services';
import Industries from '../components/home/Industries';
import Testimonials from '../components/home/Testimonials';
import CallToAction from '../components/CallToAction';

export default () => (
  <Layout>
    <Seo />
    <section className="pt-20 md:pt-40">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-center lg:text-left lg:w-1/2">
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold leading-none">
            Your Professional CPA Firm
          </h1>
          <p className="text-xl lg:text-2xl mt-6 font-light">
            Providing your small business with bookkeeping and tax services to save you time and
            money.
          </p>
        </div>
        <div className="lg:w-1/2">
          <HeroImage />
        </div>
      </div>
    </section>

    <Services />
    <Industries />
    <Testimonials />
    <CallToAction />
    <GoogleReviewBadge className="fixed max-w-none left-0 bottom-0 mb-8 ml-8 hidden md:block" />
  </Layout>
);
